import '../BranchItem/BranchItem'
import BranchItem from "../BranchItem/BranchItem";
import {useQuery} from "@apollo/client";
import {COMPANY_BRANCHES} from "../../apollo/Queries";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {apolloClientPos} from "../../apollo/ApolloClients";
import {useEffect, useState} from "react";
import Spinner from "../../components/Spinner/Spinner";
import {useDispatch, useSelector} from "react-redux";
import {resetBranchState, setBranch} from "../../store/branchReducer";
import {resetEmployeeState} from "../../store/employeeReducer";
import {resetServiceState} from "../../store/serviceReducer";
import {resetDateState} from "../../store/dateReducer";
import {resetFormState} from "../../store/formReducer";
import PageNotFound from "../../components/ErrorComponents/PageNotFound/PageNotFound";
import {useTranslation} from "react-i18next";
import {resetBookingValidate, setBookingValidate} from "../../store/bookingValidateReducer";
import {NavigationComponent} from "../../components/NavigationComponent/NavigationComponent";
import BookingUnavailableNotice from "../../components/BookingUnavailableNotice/BookingUnavailableNotice";
import {isOnlineBookingDisabledError} from "../../utils/isOnlineBookingDisabledError";

const BranchList = ({ignoreValidation, companyData}) => {
    const {t: translate} = useTranslation();
    const {companyId} = useParams();
    const dispatch = useDispatch();
    const isBookingValid = useSelector(state => state.bookingValidateReducer.validate);
    const [loading, setLoading] = useState(true);
    const [isBranchNotFound, setIsBranchNotFound] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const isOnlineBookingUnavailableRedirect = location.state?.onlineBookingUnavailable;
    const {data: companyBranchesData} = useQuery(COMPANY_BRANCHES(companyId), {
        client: apolloClientPos,
        onCompleted: () => {
            setLoading(false);
        }, onError: (error) => {
            setLoading(false);
            const shouldShowNotFound =
                !ignoreValidation &&
                !isOnlineBookingUnavailableRedirect &&
                !isOnlineBookingDisabledError(error);

            if (shouldShowNotFound) {
                setIsBranchNotFound(true);
            }
        }
    });

    useEffect(() => {
        if (ignoreValidation || isOnlineBookingUnavailableRedirect) {
            setIsBranchNotFound(false);
        }
    }, [ignoreValidation, isOnlineBookingUnavailableRedirect]);

    useEffect(() => {
        dispatch(resetBranchState());
        dispatch(resetEmployeeState());
        dispatch(resetServiceState());
        dispatch(resetDateState());
        dispatch(resetFormState());
        dispatch(resetBookingValidate());
        if (!isBookingValid) {
            dispatch(setBookingValidate({validate: true}))
        }
    }, [dispatch, isBookingValid]);

    useEffect(() => {
        if (
            companyBranchesData &&
            companyBranchesData.companyBranches.length === 1 &&
            !isOnlineBookingUnavailableRedirect
        ) {
            dispatch(setBranch({
                id : companyBranchesData.companyBranches[0].id,
                branchName : companyBranchesData.companyBranches[0].name,
                branchAddress: companyBranchesData.companyBranches[0].address,
                branchCity : companyBranchesData.companyBranches[0].city.name,
                timeZone : companyBranchesData.companyBranches[0].timeZone,
                isOneBranch : companyBranchesData.companyBranches.length === 1
            }));
            navigate(`/company/${companyId}/branch-menu-list/${companyBranchesData.companyBranches[0].id}`);
        }
    }, [companyBranchesData, companyId, dispatch, navigate, isOnlineBookingUnavailableRedirect])

    const hasCompanyBranches = companyBranchesData?.companyBranches?.length > 0;

    if (isOnlineBookingUnavailableRedirect) {
        if (!companyData?.company) {
            return <Spinner/>;
        }

        return (
            <>
                <NavigationComponent textNav={translate('branchPage.setBranch')}/>
                <BookingUnavailableNotice data={companyData}/>
            </>
        );
    }

    if (hasCompanyBranches) {
        return (
            <>
                <NavigationComponent textNav={translate('branchPage.setBranch')}/>
                {
                    companyBranchesData.companyBranches.map((branch) => (
                        <BranchItem
                            key={branch.id}
                            branchName={branch.name}
                            branchAddress={branch.address}
                            branchCity={branch.city.name}
                            branchId={branch.id}
                            companyId={companyId}
                            workingTime={branch.workSchedule}
                            closestBookingDate={branch.closestBookingDate}
                            closestBookingTimes={branch.closestBookingTimes}
                            timeZone={branch.timeZone}/>
                    ))
                }
            </>
        );
    }

    if (loading) {
        return <Spinner/>;
    }

    if (isBranchNotFound) {
        return <PageNotFound/>;
    }

    return (
        <>
            <NavigationComponent textNav={translate('branchPage.setBranch')}/>
            <BookingUnavailableNotice data={companyData}/>
        </>
    )
}

export default BranchList